import { Link, useLocation } from '@tanstack/react-router';
import { useAppStore } from '@/stores/app';
import { useAuthStore } from '@/stores/auth';
import { cn } from '@/lib/cn';
import {
  Flame,
  LayoutGrid,
  PenLine,
  Clapperboard,
  BarChart3,
  Brain,
  Film,
  Inbox,
  Library,
  Settings,
  Shield,
  Trash2,
  Users,
} from 'lucide-react';

const nav = [
  { to: '/radar', label: '热点雷达', icon: Flame, color: '#FFB400' },
  { to: '/projects', label: '项目大厅', icon: LayoutGrid, color: '#7C5CFF' },
  { to: '/writer', label: '编剧工作台', icon: PenLine, color: '#6750A4' },
  { to: '/director', label: '制作工作台', icon: Clapperboard, color: '#0061A4' },
  { to: '/compose', label: '合成工作台', icon: Film, color: '#0061A4' },
  { to: '/ops', label: '运营中心', icon: BarChart3, color: '#7D5260' },
  { to: '/brain', label: '数字资产', icon: Brain, color: '#006E1C' },
  { to: '/tickets', label: '工单收件箱', icon: Inbox, color: '#7D5260' },
  { to: '/assets', label: '资产库', icon: Library, color: '#605D64' },
];

export function Drawer() {
  const { drawerCollapsed } = useAppStore();
  const role = useAuthStore((s) => s.user?.role);
  const loc = useLocation();
  const showMembersLink = role === 'TENANT_ADMIN';
  const showAdminLink = role === 'SUPER_ADMIN' || role === 'TENANT_ADMIN';
  return (
    <aside
      className={cn(
        'sticky top-14 hidden h-[calc(100vh-3.5rem)] shrink-0 border-r border-outline-variant/20 bg-surface transition-all duration-medium2 ease-standard md:block',
        drawerCollapsed ? 'w-16' : 'w-60',
      )}
    >
      <nav className="flex h-full flex-col gap-1 p-2">
        {nav.map((item) => {
          const Icon = item.icon;
          const active = loc.pathname.startsWith(item.to);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={cn(
                'group flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-short3',
                active
                  ? 'bg-brand-50 text-brand-600 dark:bg-brand-900/20'
                  : 'text-neutral-700 hover:bg-surface-variant',
              )}
            >
              <Icon className="h-5 w-5 shrink-0" style={{ color: active ? item.color : undefined }} />
              {!drawerCollapsed && <span>{item.label}</span>}
            </Link>
          );
        })}
        <div className="mt-auto space-y-1">
          {showMembersLink && (
            <Link
              to="/iam/members"
              className="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-neutral-600 hover:bg-surface-variant"
            >
              <Users className="h-5 w-5" />
              {!drawerCollapsed && <span>成员</span>}
            </Link>
          )}
          {showAdminLink && (
            <Link
              to="/admin"
              className="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-neutral-600 hover:bg-surface-variant"
            >
              <Shield className="h-5 w-5" />
              {!drawerCollapsed && <span>管理员</span>}
            </Link>
          )}
          <Link
            to="/trash"
            className="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-neutral-600 hover:bg-surface-variant"
          >
            <Trash2 className="h-5 w-5" />
            {!drawerCollapsed && <span>回收站</span>}
          </Link>
          <Link
            to="/settings"
            className="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-neutral-600 hover:bg-surface-variant"
          >
            <Settings className="h-5 w-5" />
            {!drawerCollapsed && <span>设置</span>}
          </Link>
        </div>
      </nav>
    </aside>
  );
}
